import React from "react";

const DocumentPreview = () => {
  return (
    <svg
      viewBox="0 0 88 110"
      height="110"
      width="88"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <path
          d="M3 0h56.928a5 5 0 0 1 3.536 1.464l15.072 15.072A5 5 0 0 1 80 20.07V101a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
          id="a"
        ></path>
      </defs>
      <g transform="translate(4 3)" fill="none" fill-rule="evenodd">
        <use fill="#e55496" filter="url(#filter-3)"></use>
        <use fill="#e55496"></use>
        <path
          stroke-opacity="1"
          stroke="#e55496"
          d="M3-.5h56.929a5.5 5.5 0 0 1 3.889 1.61l15.071 15.072a5.5 5.5 0 0 1 1.611 3.89V101a3.5 3.5 0 0 1-3.5 3.5H3A3.5 3.5 0 0 1-.5 101V3A3.5 3.5 0 0 1 3-.5z"
          fill="url(#linearGradient-1)"
        ></path>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="28"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="33"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="38"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="43"
          width="40"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="53"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="58"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="63"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="68"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="73"
          width="52"
          height="2"
          rx="0.5"
        ></rect>
        <rect
          fill-opacity="1"
          fill="#e55496"
          x="13"
          y="78"
          width="27"
          height="2"
          rx="0.5"
        ></rect>
        <path
          d="M61.5.5v15a3 3 0 0 0 3 3h15"
          stroke-opacity="0.12"
          stroke="#e55496"
          fill="#e55496"
        ></path>
      </g>
    </svg>
  );
};

export default DocumentPreview;
